// import { createAsyncThunk } from "@reduxjs/toolkit";
// import { baseUrl } from "../../boot/index";
// import axios from "axios";

// // get  Employees 
// export const getEmployees = createAsyncThunk("/get-employees", async (data) => {
//     const token = localStorage.getItem("authToken")

//     try {
//         const response = await axios.post(`${baseUrl}cleaningappfunctions/hrm/app/v1/get-employees`, data, { 
//             headers: {
//                 "auth-token": token,
//             }
//         },);
//         console.log({ response })
//         return response;
//     } catch (error) {
//         console.error('Error fetching employees - ', error);
//         throw error;
//     }
// })


import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index";
import axios from "axios";

// get Employees 
export const getEmployees = createAsyncThunk("/get-employees", async (data) => {
    const token = localStorage.getItem("authToken")

    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/hrm/app/v1/get-employees`, data, { 
            headers: {
                "auth-token": token,
            }
        });
        
        // Return only the data part, not the entire axios response
        return response.data;
        
    } catch (error) {
        console.error('Error fetching employees - ', error);
        throw error;
    }
})